import { useEffect } from 'react';
import { getSavedCheckoutData } from 'utils/helpers/checkout';
import { useAppNavigation } from 'utils/hooks';
import { useParams } from 'react-router-dom';
import { validateCheckoutBilling } from 'pages/CheckoutBilling/CheckoutBillingValidations';

export const withCheckoutBillingConfigured = (CheckoutPage: React.ComponentType) => {
  const WrappedComponent = () => {
    const { transactionId } = useParams();
    const { redirectToCheckoutBilling } = useAppNavigation();
    const { billingAddress, poNumber, csapEnrolled } = getSavedCheckoutData(transactionId);

    useEffect(() => {
      const { isAllDataValid } = validateCheckoutBilling({
        billingAddress,
        poNumber,
        csapEnrolled,
      });

      if (!isAllDataValid) {
        redirectToCheckoutBilling();
      }
    }, [billingAddress, poNumber, csapEnrolled, redirectToCheckoutBilling]);

    return <CheckoutPage />;
  };

  return WrappedComponent;
};
